module.exports = __webpack_public_path__ + "img/gerch-team-ipad.0c50a032.png";